// extracted by mini-css-extract-plugin
export default {"page":"Page_page__Onzhpuoi","title":"Page_title__HQkIxhJS"};